// contentStringsEn.js
const contentStringsEn = {
  stage0: `     <iframe src="${process.env.PUBLIC_URL}/stage0.html" style="width: 100%; height: 800px; border-radius: 20px"></iframe>

 `,
  stage1: `    <iframe src="${process.env.PUBLIC_URL}/stage1.html" style="width: 100%; height: 800px; border-radius: 20px;"></iframe>
`,
  stage2: `    <iframe src="${process.env.PUBLIC_URL}/stage2.html" style="width: 100%; height: 800px; border-radius: 20px;"></iframe>
`,
  stage3: `    <iframe src="${process.env.PUBLIC_URL}/stage3.html" style="width: 100%; height: 800px; border-radius: 20px;"></iframe>
`,
  stage4: `    <iframe src="${process.env.PUBLIC_URL}/stage4.html" style="width: 100%; height: 800px; border-radius: 20px;"></iframe>
`,
  stage5: `    <iframe src="${process.env.PUBLIC_URL}/stage5.html" style="width: 100%; height: 800px; border-radius: 20px;"></iframe>
`,
  stage6: `    <iframe src="${process.env.PUBLIC_URL}/stage6.html" style="width: 100%; height: 800px; border-radius: 20px;"></iframe>
`,
  stage7: `    <iframe src="${process.env.PUBLIC_URL}/stage7.html" style="width: 100%; height: 800px; border-radius: 20px;"></iframe>
`,
  // Add more stages as needed
};

export default contentStringsEn;
